import { CSSObject } from '@emotion/react'

export const headerTabsStyles = (): {
  [key: string]: Record<string, CSSObject | string | number>
} => ({
  tabsContainer: {
    display: 'flex',
    cursor: 'pointer',
    background: '#F6F6F6',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    padding: 0,
    gap: 4,
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
})
